import Cover from "../cover";
import type { PhotoBookOptions, ProductSettingsProps } from "../../../types";

function ProductSettings({
  productId,
  userId,
  options,
  setOptions,
}: ProductSettingsProps<PhotoBookOptions>) {
  return <Cover productId={productId} userId={userId} options={options} setOptions={setOptions} />;
}

export default ProductSettings;
